import React from 'react';
import Layout from 'components/layout';
import SEO from 'components/seo';

// Component
import Hero from 'components/molecules/Hero/Hero';
import TextImageBlock from 'components/organisms/Blocks/TextImageBlock/TextImageBlock';

// Data
import OverOnsData from 'data/OverOnsPage.json';

const OverOnsPage = () => (
  <Layout>
    <TextImageBlock
      data={OverOnsData.intro}
    />
    <Hero
      modifier="inPage"
      {...OverOnsData.inPageHero}
    />
  </Layout>
);
export default OverOnsPage;

export const Head = () => (
  <SEO title="Over ons" />
);
